export const basename = '/arbeidsforhold/';
